import $ from 'jquery';

export const fadeAnimationMS = 300;
export const fadeInTimeoutMS = 500;
export const fadeOutTimeoutMS = 30000;

export function fadeIn(selector) {
  $(selector).fadeIn(fadeAnimationMS);
}

export function fadeOut(selector) {
  $(selector).fadeOut(fadeAnimationMS);
}

export function isClicked(key) {
  return localStorage.getItem(key) === 'true';
}

export function saveClick(key) {
  localStorage.setItem(key, 'true');
}

export function resetClick(key) {
  localStorage.removeItem(key);
}

export function isClickOutside(event, selectors) {
  return selectors.every((selector) => !event.target.closest(selector));
}

export function handleFadeInOut(selector) {
  fadeIn(selector);
  setTimeout(() => fadeOut(selector), fadeOutTimeoutMS);
}
